import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ConnectButtons } from './ConnectButtons'
import { GenerateButton } from './GenerateButton'
import { VISUAL_ANALYSIS_SUPPORTED_INTEGRATIONS } from './constants'
import { BrandVisualKit } from 'types'

interface Props {
  selectedIntegration?: ExternalIntegration
  onConfirm: (kit: BrandVisualKit) => void
}

export const PrimaryButtons = ({ selectedIntegration, onConfirm }: Props) => {
  const { data, isLoading } = useExternalIntegrations()

  if (isLoading || !data) {
    return null
  }

  const integrations = data.external_integrations.filter((integration) =>
    VISUAL_ANALYSIS_SUPPORTED_INTEGRATIONS.includes(integration.provider),
  )

  if (selectedIntegration || integrations.length > 0) {
    return <GenerateButton integration={selectedIntegration} onConfirm={onConfirm} />
  }

  return <ConnectButtons />
}
